import { faMoneyBill, faMoneyCheck, faUserEdit, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'
import { LangAddEmployee, LangBPJSEmployee, LangEmployee, LangOutOfQuota, LangOutOfQuotaMessage, LangPPH21, LangSubscriptionSetting, LangUpdateEmployee } from '../../constant/languange'
import { checkAuthorization, Link, mapStateToProps } from '../../helpers/Common'
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap'

function PersonnelImportComponent({ redux, setControl, canAdd }) {
  return (
    <>
      <div className='d-flex w-100'>
        <button id='popover-import-personnel' className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => { canAdd && setControl(control => ({ ...control, showModal: 'import-create' })) }}>
          <FontAwesomeIcon icon={faUserPlus} size='3x' />
          <span className='mt-2'>{LangAddEmployee}</span>
        </button>
        {!canAdd && (
          <UncontrolledPopover
            placement='bottom'
            target='popover-import-personnel'
            trigger='legacy'
          >
            <PopoverHeader className='bg-light text-dark'>
              {LangOutOfQuota}
            </PopoverHeader>
            <PopoverBody>
              <p>
                {LangOutOfQuotaMessage} {checkAuthorization(redux, 'employee.buy-quota') && (<Link to='/subscribe'>{LangSubscriptionSetting.toLowerCase()}</Link>)}.
              </p>
            </PopoverBody>
          </UncontrolledPopover>
        )}
        <button className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => { setControl(control => ({ ...control, showModal: 'import-update' })) }}>
          <FontAwesomeIcon icon={faUserEdit} size='3x' />
          <span className='mt-2'>{LangUpdateEmployee}</span>
        </button>
        <button className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => { setControl(control => ({ ...control, showModal: 'import-bpjs' })) }}>
          <FontAwesomeIcon icon={faMoneyCheck} size='3x' />
          <span className='mt-2'>{LangBPJSEmployee}</span>
        </button>
        {redux.enableFeaturePayroll && (
          <button className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => { setControl(control => ({ ...control, showModal: 'import-pph21' })) }}>
            <FontAwesomeIcon icon={faMoneyBill} size='3x' />
            <span className='mt-2'>{LangPPH21} {LangEmployee}</span>
          </button>
        )}
      </div>
    </>
  )
}

export default connect(mapStateToProps)(PersonnelImportComponent)
